import { render, staticRenderFns } from "./CetakResepObat.vue?vue&type=template&id=530db0a4&"
import script from "./CetakResepObat.vue?vue&type=script&lang=js&"
export * from "./CetakResepObat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports